import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-how-does-work',
  templateUrl: './how-does-work.page.html',
  styleUrls: ['./how-does-work.page.scss'],
})
export class HowDoesWorkPage implements OnInit {

  @Input() how: { color: string; title: string, content: string[] } = {
    color: 'sunflower',
    title: 'Titles.how-does-promotion-work',
    content: [ '' ]
  };

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onConfirm = () => this.modalCtrl.dismiss(true);

}
